module.exports = __webpack_public_path__ + "img/PARTE_CENTRIF_EXTRACTOR.0d72da4d.jpg";